import { Trans, useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

import DefaultAuth from "./DefaultAuth";
import SignInForm from "./Forms/SignIn";

function SignIn() {
	const { t } = useTranslation();
	const { state } = useLocation();
	const { id } = useParams();

	const renderAlert = () => {
		if (!state) {
			return null;
		}

		if (state.email) {
			return (
				<div className="alert--correct p-8 border-radius-8">
					<Trans
						i18nKey="auth.alerts.accountCreated"
						values={{ email: state.email }}
						components={[<strong key="created" />]}
					/>
				</div>
			);
		}

		if (state.passwordChanged) {
			return (
				<div className="alert--correct p-8 border-radius-8">
					{t("auth.alerts.passwordChanged")}
				</div>
			);
		}

		return null;
	};

	return (
		<DefaultAuth
			Form={SignInForm}
			title={
				id
					? t("auth.services.signInToService", {
							serviceName: id.toUpperCase(),
						})
					: t("auth.services.selectService")
			}
			Alert={renderAlert()}
		/>
	);
}

export default SignIn;
